<template>
  <div>
    <Nav></Nav>
  </div>
</template>

<script>
import Nav from './nav.vue';
  export default {
    components: {
      Nav
    },
    data() {
      return {
      }
    },
  }
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/index.vue